import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/ajustes/establecimiento';
import Establecimiento from './Establecimiento';


const ms2p = (state) => {
  return {
    ...state.establecimiento,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Establecimiento);
